const knockout = {
  err_invalid_status: {
    message: 'Failed to enable auto-rejection rule. Try again later.',
  },
  err_invalid_scope: {
    message: 'Failed to enable auto-rejection rule. Try again later.',
  },
  err_ats_form_template_not_found: {
    message:
      'Auto-rejection rule creation failed as the rejection email template is invalid',
  },
  err_rules_email_template_save_failed: {
    message:
      'Auto-rejection rule creation failed as the rejection email template is invalid',
  },
  err_rules_email_template_build_failed: {
    message:
      'Auto-rejection rule creation failed as the rejection email template is invalid',
  },
  err_failed_to_clone_rules: {
    message: 'Auto-rejection rule creation failed while creating the job',
  },
  err_failed_to_enqeue_auto_rejection_worker: {
    message: 'Auto-rejection rule creation failed while creating the job',
  },
  err_failed_to_create_criteria: {
    message:
      ' Auto-rejection rule creation failed as the rejection criteria is invalid',
  },
  err_failed_to_save_rule: {
    message: ' Auto-rejection rule creation failed. Try again later.',
  },
  err_failed_to_update_rule: {
    message: 'Auto-rejection rule update failed. Try again later.',
  },
  access_denied: {
    message: 'You are not authorized to perform this action.',
  },
};

export default knockout;
